import { useTranslation } from 'react-i18next';
import { ConfirmDialog } from '@/shared/ui/dialogs/ConfirmDialog';
import { useEntityDelete } from '@/shared/hooks/useEntityDelete';
import { queryKeys } from '@/shared/api/queryKeys';
import { apiParcelsDelete } from '@/entities/parcels';
import type { ApiParcelsGetItem } from '@/shared/types/api/parcels';

type Props = {
  parcel: ApiParcelsGetItem | null;
  onClose: () => void;
  onDeleted?: () => void;
};

export const FeaturesParcelsDeleteDialog = ({ parcel, onClose, onDeleted }: Props) => {
  const { t } = useTranslation();

  const remove = useEntityDelete({
    api: (id: string) => apiParcelsDelete(id),
    invalidateKeys: [queryKeys.parcels.all, queryKeys.pinfl.all],
    successKey: 'parcels.delete.toast.deleted',
    onSuccess: () => {
      onClose();
      onDeleted?.();
    },
  });

  return (
    <ConfirmDialog
      open={Boolean(parcel)}
      title={t('parcels.delete.title')}
      description={t('parcels.delete.description', { name: parcel?.name ?? '' })}
      confirmLabel={t('parcels.delete.confirm')}
      cancelLabel={t('parcels.delete.cancel')}
      confirmVariant="danger"
      loading={remove.isPending}
      onConfirm={() => parcel && remove.mutate(parcel.id)}
      onCancel={onClose}
    />
  );
};
